import { useLocation } from 'react-router'

import useFeatureFlag from 'hooks/useFeatureFlag'

import SimpleA from '../../display/SimpleAnchor'
import Banner from '../Banner'
import { useCurrentVisit } from '../../auth/withCurrentVisit'

export const WildfiresBannerComponent = () => {
  return (
    <Banner>
      Riparide will donate 100% of profits for October &amp; November to the{' '}
      <SimpleA
        target="_blank"
        href="https://www.redcross.org/about-us/our-work/disaster-relief/wildfire-relief/hawaii-wildfires.html"
      >
        American Red Cross Hawaii Wildfires Relief
      </SimpleA>
    </Banner>
  )
}

const WildfiresBannerUS = () => {
  const { data: currentVisit } = useCurrentVisit()

  const isUS = currentVisit?.data?.country?.code === 'US'

  if (isUS) {
    return <WildfiresBannerComponent />
  }
  return null
}

const displayOnRoutes = ['/washington', '/oregon', '/california']
const displayOnRouteFragments = ['/stories/', '/listings/', '/payment']

export default () => {
  const { pathname } = useLocation()

  const hasFeatureFlag = useFeatureFlag('wildfires_banner')

  const matchingRoutes = displayOnRoutes.filter((path) => path === pathname)

  const matchingRouteFragments = displayOnRouteFragments.filter((fragment) =>
    pathname.includes(fragment)
  )

  const display = matchingRoutes.length > 0 || matchingRouteFragments.length > 0

  if (hasFeatureFlag && display) {
    return <WildfiresBannerUS />
  }

  return null
}
